import type { PaletteColor } from "@mui/material";
import type {
  Components,
  PaletteColorOptions,
  Theme,
} from "@mui/material/styles";

import type { ColorName } from "../../options/palette";

declare module "@mui/material" {
  interface ChipPropsVariantOverrides {
    dark: true;
    light: true;
  }
}

export const MuiChip: Components<Theme>["MuiChip"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      variants: [
        ...Object.entries(theme.palette)
          .filter((args): args is [ColorName, PaletteColor] => {
            const [, values] = args;
            return typeof values === "object" && "dark" in values;
          })
          .map(([color, values]) => ({
            props: {
              color,
              variant: "dark" as const,
            },
            style: {
              backgroundColor: values.dark,
            },
          })),
        ...Object.entries(theme.palette)
          .filter(
            (args): args is [ColorName, PaletteColorOptions & PaletteColor] => {
              const [, values] = args;
              return typeof values === "object" && "light" in values;
            },
          )
          .map(([color, values]) => ({
            props: {
              color,
              variant: "light" as const,
            },
            style: {
              backgroundColor: values.light,
              color: (1000 in values ? values[1000] : undefined) ?? values.dark,

              "&.Mui-disabled": {
                color: theme.palette.text.secondary,
                opacity: 1,
              },

              "&:not(.Mui-disabled) .MuiChip-icon": {
                color: values.dark,
              },
            },
          })),
      ],
    }),

    sizeSmall: ({ theme }) => ({
      fontSize: theme.typography.fontSizeSm,
    }),
  },
};
